<div class="d-flex flex-column fill">
  <main class="container-fluid flex-fill">
    <router-outlet></router-outlet>
  </main>
</div>
